import React from 'react';
import { Link } from 'react-router-dom';

export default function MainPage({ name }) {
  return (
    <div className="App">
      <div>
        <title>BEN VEGEL - MAIN PAGE</title>
        <meta name="description" content="Welcome to video content from the main page. A distant ridge line as backdrop for forest scenery was gorgeous while traversing nearby mountain terrain..." />
        
        <div class = "wrapper">
          <div class = "zaviti">
            <h1>SKIING</h1>
            <h2>Adventure</h2>

            <div class = "video-container">
              <div class = "zaviti-urejeno-video">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/BJIC2yeglrc" title = "THE GULLIES SKI LINE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
            
            <h2 class = "stylized">Find snow:</h2>
          
            <div class = "video-container">
              <div class = "zaviti-urejeno-video">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Lg3opLHO_s8" title = "MAJESTIC POWDER TRACKS" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>

            <p>Skiing fresh snow around the mountains where pockets of powder reached several feet deep.</p>
            <p>Advanced alpine trails were exciting under the bluebird sky.</p>
            <p>A distant ridge line as backdrop for forest scenery was gorgeous while traversing nearby mountain terrain.</p>
            <p>Powder conditions made waiting worthwhile for access of steep zones ready to ski!</p>
          </div>
          
          <div class = "zaviti">
            <h1 class = "stil">Smučarski</h1>
            <h2 class = "stil">Kaj boste?</h2>

            <div class = "video-zaviti">
              <div class = "zaviti-urejeno-video">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/gYopT-v2uYU" title = "NO NAME POWDER LAPS" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>

            <h3 class = "stil">iz Združenih držav Amerike</h3>
            
            <h2 class = "stil">Mrzel</h2>

            <div class = "slika_b" id = "slika_e">

            </div>

            <div class = "video-zaviti">
              <div class = "zaviti-urejeno-video">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/NQkJF_7OmZQ" title = "BRAVE CHUTE SKIING" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>

            <div class = "slika" id = "slika_c_b">
            </div>
            
            <h2 class = "stil">Ne skrbi</h2>

            <div class = "slika_b" id = "slika_d">

            </div>

            <div class = "slika" id = "slika_a_c">
            </div>
          </div>

          <p>Privacy Practice for the current web application made special considerations for the EU, UK, and Canada.</p>
          <p>While specific examples and profiles may have been extended across international borders, it was important that certain sports models demonstrated activities like skiing in the United States.</p>
          <p>Vital interests included information processed for protection and to consider the vital interests of a third party like public comments.</p>
          <p>Collection of personal information was legally permitted for special demonstrations that were carried out within timely manners.</p>
        </div>
      </div>
    </div>
  );
}
